import { apiRoutes } from 'config/apiRoutes'
import { defaultConfig } from 'config/default'
import { useMutation } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { downloadAs } from 'utils/downloadFile'

type UseExportPayoutsMutationProps = {
	chosenExportFormat: number | string | null
	checkedPayouts: number[]
	clearSelection: () => void
	onSettled: () => void
}

export const useExportPayoutsMutation = ({
	chosenExportFormat,
	checkedPayouts,
	clearSelection,
	onSettled
}: UseExportPayoutsMutationProps) => {
	const axiosPrivate = useAxiosPrivate()
	const { t } = useTranslation()

	const { mutate: exportPayoutsMutation, isPending: isExportPayoutsLoading } = useMutation({
		mutationFn: () => {
			return axiosPrivate.post(
				apiRoutes.payoutsExport,
				{ format: chosenExportFormat, ids: checkedPayouts },
				{ responseType: 'arraybuffer' }
			)
		},
		onSuccess: (res) => {
			const format = defaultConfig.exportFormatOptions
				.find((format) => format.value === chosenExportFormat)
				?.label.toLowerCase()

			if (format) {
				downloadAs({ file: res.data, name: 'payouts-export', format })
			}
			useToast({
				type: 'success',
				message: t('Payouts exported')
			})()

			clearSelection()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		exportPayoutsMutation,
		isExportPayoutsLoading
	}
}
